import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../contexts/en';
import es from '../contexts/es';

const LANGUAGE_STORAGE_KEY = 'app_language';

function getInitialLanguage(): string {
  if (typeof localStorage !== 'undefined') {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (stored) {
      return stored;
    }
  }
  return 'en';
}

/**
 * Spanish strings that must never be truncated, even if they exceed 40 chars.
 * Matched by prefix so minor punctuation or whitespace differences don't matter.
 */
const TRUNCATION_EXEMPT_PREFIXES: string[] = [
  'Bienvenido a la Pantalla de Inicio de Tienda',
  'Bienvenido a la pantalla de inicio de sesión de la tienda',
  'La orden de trabajo excede el límite de gasto',
  '¿Estás seguro de que quieres cerrar sesión',
  '¿Estás seguro de que quieres finalizar tu turno',
  'Finalizar tu turno te bloqueará',
  '¿Estás seguro de que deseas finalizar la reparación',
  'Finalizar la reparación te bloqueará',
  'Arrastre los archivos aquí o haga clic para cargarlos',
  'Formatos compatibles: prn, aspx, bin, doc, docx, gif, jpeg, jpg, pdf, png, .xls y .xlsx. Tamaño máximo del archivo: 3 MB',
  'Puede comenzar a trabajar en esta reparación inmediatamente o ir al panel.',
  // Covers both "message" and "messageWithDestination" (static part before {{destination}})
  'Los detalles de su Orden de Trabajo se han guardado correctamente',
  '¿Desea salir de la Creación de Reparación?',
  'Aún no ha completado el proceso de creación de la orden de trabajo.',
  '¿Desea continuar creando la orden de trabajo?',
  'El límite de gasto de la Orden de Trabajo ha sido alcanzado. Se requiere autorización para continuar.'
];

/**
 * Regex patterns for strings with dynamic interpolated values that must never
 * be truncated. Use these when the dynamic part makes a plain prefix too broad.
 */
const TRUNCATION_EXEMPT_PATTERNS: RegExp[] = [
  // Matches: "La reparación <repairNumber> se añadió correctamente."
  /^La reparación .+ se añadió correctamente\.$/,
];

i18n.use({
  type: 'postProcessor',
  name: 'truncateSpanish',
  process: (value: any, _key: string, _options: any, translator: any) => {
    if (
      translator.language === 'es' &&
      typeof value === 'string' &&
      value.length > 40 &&
      !TRUNCATION_EXEMPT_PREFIXES.some(prefix => value.startsWith(prefix)) &&
      !TRUNCATION_EXEMPT_PATTERNS.some(pattern => pattern.test(value))
    ) {
      return value.substring(0, 40) + '...';
    }
    return value;
  },
});

// Initialize the i18n library configuration
i18n.use(initReactI18next).init({
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
  },
  postProcess: 'truncateSpanish',
  react: {
    useSuspense: false,
  },
});

// Keep <html lang="…"> in sync with the active locale (web only)
if (typeof document !== 'undefined') {
  document.documentElement.lang = i18n.language;
  i18n.on('languageChanged', (lng: string) => {
    document.documentElement.lang = lng;
  });
}

export default i18n;
